import { VariablesOf } from '@graphql-typed-document-node/core';
import { queryOptions } from '@tanstack/react-query';

import { accountRequester } from 'queries/requesters';
import {
  GetAccountAddressesDocument,
  GetAccountDocument,
  GetLoyaltyTiersDocument,
} from 'types/api/account.types';

export const ACCOUNT_PREFIX = 'account';

export const accountQuery = queryOptions({
  queryKey: [ACCOUNT_PREFIX, 'me'],
  queryFn: accountRequester(GetAccountDocument),
});

export const accountAddressesQuery = queryOptions({
  queryKey: [ACCOUNT_PREFIX, 'addresses'],
  queryFn: accountRequester(GetAccountAddressesDocument),
});

export const accountSaudiRewardsBalanceQuery = queryOptions({
  queryKey: [ACCOUNT_PREFIX, 'saudi-rewards', 'balance'],
});

export const loyaltyTiersQuery = (
  variables: VariablesOf<typeof GetLoyaltyTiersDocument>,
) =>
  queryOptions({
    queryKey: [ACCOUNT_PREFIX, 'loyalty', 'tiers', variables.locale],
    queryFn: accountRequester(GetLoyaltyTiersDocument, variables),
  });
